import Vue from "vue";

const state = {
	incomedeclarations_options: {
		page: 1,
		itemsPerPage: null,
		sortBy: ["ref_year"],
		sortDesc: [true],
		groupBy: [],
		groupDesc: [],
		mustSort: false,
		multiSort: false,
		search: null,
	},
	incomedeclarations: {},
	_incomedeclarations_loading: 0,
	showCreateEditIncomeDeclarations: false,
	currentIncomeDeclarations: {},
	_incomedeclarations_exporting: 0,
};

const getters = {
	getIncomeDeclarationsOptions: (state) => state.incomedeclarations_options,
	getIncomeDeclarations: (state) => state.incomedeclarations,
	incomedeclarations_loading: (state) => state._incomedeclarations_loading !== 0,
	showCreateEditIncomeDeclarations: (state) => state.showCreateEditIncomeDeclarations,
	getCurrentIncomeDeclarations: (state) => state.currentIncomeDeclarations,
	incomedeclarations_exporting: (state) => state._incomedeclarations_exporting !== 0,
};

const actions = {
	fetchIncomeDeclarations({ commit, dispatch }) {
		commit("START_INCOMEDECLARATIONS_LOADING");
		axios
			.get("/api/incomedeclarations", { params: state.incomedeclarations_options })
			.then((res) => {
				commit("setIncomeDeclarations", res.data);
			})
			.catch((err) => {
				dispatch("handleError", err);
			})
			.then(function () {
				commit("STOP_INCOMEDECLARATIONS_LOADING");
			});
	},
	createIncomeDeclarations({ commit, dispatch, rootState }) {
		commit("START_INCOMEDECLARATIONS_LOADING");
		if (!state.currentIncomeDeclarations.id) {
			return new Promise((resolve, reject) => {
				axios
					.post("/api/incomedeclarations", state.currentIncomeDeclarations)
					.then((res) => {
						dispatch("handleResponseMessage", res.data);
						if (res.data.object) {
							dispatch("setCurrentModelForAttachment", {
								object: res.data.object,
								filecategory: "incomedeclarations",
							});
							if (!_.isEmpty(rootState.attachments.temporaryAttachment)) {
								Object.keys(rootState.attachments.temporaryAttachment).forEach((newattachmentindex) => {
									dispatch("uploadTemporaryAttachment", rootState.attachments.temporaryAttachment[newattachmentindex])
										.then((attachmentres) => {
											if (newattachmentindex == rootState.attachments.temporaryAttachment.length - 1) {
												dispatch("fetchIncomeDeclarations");
												dispatch("hideAction", "hideCreateEditIncomeDeclarations");
											}
										})
										.catch((err) => {
											if (newattachmentindex == rootState.attachments.temporaryAttachment.length - 1) {
												dispatch("fetchIncomeDeclarations");
												dispatch("hideAction", "hideCreateEditIncomeDeclarations");
											}
										});
								});
							} else {
								dispatch("fetchIncomeDeclarations");
								dispatch("hideAction", "hideCreateEditIncomeDeclarations");
							}
						}
						resolve(res.data);
					})
					.catch((err) => {
						dispatch("handleError", err);
						reject(err);
					})
					.then(function () {
						commit("STOP_INCOMEDECLARATIONS_LOADING");
					});
			});
		} else {
			return new Promise((resolve, reject) => {
				axios
					.put("/api/incomedeclarations/" + state.currentIncomeDeclarations.id, state.currentIncomeDeclarations)
					.then((res) => {
						if (res.data.object) {
							dispatch("fetchIncomeDeclarations");
							dispatch("hideAction", "hideCreateEditIncomeDeclarations");
						}
						dispatch("handleResponseMessage", res.data);
						resolve(res.data);
					})
					.catch((err) => {
						dispatch("handleError", err);
						reject(err);
					})
					.then(function () {
						commit("STOP_INCOMEDECLARATIONS_LOADING");
					});
			});
		}
	},
	deleteIncomeDeclarations({ commit, dispatch }, id) {
		commit("START_INCOMEDECLARATIONS_LOADING");
		return new Promise((resolve, reject) => {
			axios
				.delete("/api/incomedeclarations/" + id)
				.then((res) => {
					dispatch("handleResponseMessage", res.data);
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_INCOMEDECLARATIONS_LOADING");
					if (state._incomedeclarations_loading == 0) {
						dispatch("fetchIncomeDeclarations");
					}
				});
		});
	},
	exportIncomeDeclarations({ commit, dispatch }, type) {
		commit("START_INCOMEDECLARATIONS_EXPORTING");
		axios
			.post("/api/incomedeclarations/export-download", state.incomedeclarations_options, { responseType: "arraybuffer" })
			.then((res) => {
				dispatch("downloadFromResponse", res);
			})
			.catch((err) => {
				dispatch("handleError", err);
			})
			.then(function () {
				commit("STOP_INCOMEDECLARATIONS_EXPORTING");
			});
	},
	readIncomeDeclarationFromFile({ commit, dispatch }, formData) {
		commit("START_UPLOADATTACHMENT_LOADING");
		const source = axios.CancelToken.source();
		commit("setSource", source);
		commit("setProgress", { total: 100, loaded: 0 });
		return new Promise((resolve, reject) => {
			axios
				.post("/api/incomedeclarations/readfromfile", formData, {
					cancelToken: source.token,
					onUploadProgress: (e) => {
						commit("setProgress", { total: e.total, loaded: e.loaded });
					},
				})
				.then((res) => {
					dispatch("handleResponseMessage", res.data);
					if (res.data.object) {
						commit("setCurrentIncomeDeclarations", res.data.object);
					}
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_UPLOADATTACHMENT_LOADING");
				});
		});
	},
};
const mutations = {
	setIncomeDeclarationsOptions(state, value) {
		Vue.set(state, "incomedeclarations_options", value);
	},
	setIncomeDeclarations(state, data) {
		Vue.set(state, "incomedeclarations", data);
	},
	START_INCOMEDECLARATIONS_LOADING(state) {
		state._incomedeclarations_loading++;
	},
	STOP_INCOMEDECLARATIONS_LOADING(state) {
		state._incomedeclarations_loading--;
	},
	showCreateEditIncomeDeclarations(state) {
		state.showCreateEditIncomeDeclarations = true;
	},
	hideCreateEditIncomeDeclarations(state) {
		state.showCreateEditIncomeDeclarations = false;
	},
	setCurrentIncomeDeclarations(state, value) {
		Vue.set(state, "currentIncomeDeclarations", value);
	},
	START_INCOMEDECLARATIONS_EXPORTING(state) {
		state._incomedeclarations_exporting++;
	},
	STOP_INCOMEDECLARATIONS_EXPORTING(state) {
		state._incomedeclarations_exporting--;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
